import React, { FC, useEffect, useState, useRef } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import TopBlock from './TopBlock';
import { RootStoreType } from 'src/types/store';
import { allColumns } from './constants';
import TableSimple from 'src/components/TableSimple';
import { ExportTypeType, TableRefType } from 'src/types/table';
import { useCheckPermission } from 'src/utils/checkPermission';
import { UserDetailIcon } from 'src/components/SkladonIcon/SmallIcons';
import { getProviderCompaniesListFetch } from 'src/resources/providerCompaniesList/reducer';

const ProviderCompaniesListContainer: FC = (props) => {
    const dispatch = useDispatch();
    const tableRef = useRef<TableRefType>();
    const [activeTab, setActiveTab] = useState<string>('providerCompanies');

    const loading = useSelector((state: RootStoreType) => state.providerCompaniesList.loading);
    const providerCompaniesData = useSelector((state: RootStoreType) => state.providerCompaniesList.data);

    const permissionCreate = useCheckPermission('PROVIDER_COMPANIES.CREATE');
    const permissionDetail = useCheckPermission('PROVIDER_COMPANIES.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('providerCompanies.title') }));
        dispatch(getProviderCompaniesListFetch());
    }, []);

    const reloadProviderCompaniesList = () => {
        dispatch(activeTab === 'providerCompanies' ? getProviderCompaniesListFetch() : getProviderCompaniesListFetch());
    };

    const handleExport = (type: ExportTypeType) => {
        tableRef.current?.exportTable(type, translate('providerCompanies.action.exportFileName'));
    };

    return (
        <>
            <TopBlock
                reloadProviderCompaniesList={reloadProviderCompaniesList}
                permissionCreate={permissionCreate}
                handleExport={handleExport}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
            <TableSimple
                tableRef={tableRef}
                rowIdKey="ID"
                rows={providerCompaniesData || []}
                loading={loading}
                columsLabelPrefix="providerCompanies.table"
                allColumns={allColumns}
                initSort={{ column: 'ID', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <UserDetailIcon />,
                        label: translate('providerCompanies.action.providerCompanyDetail'),
                        getLink: (row) => `/settings/provider_companies/${row.ID}/`,
                        hiddenFce: () => !permissionDetail,
                    },
                ]}
                selectOptions={{}}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="providerCompaniesTable"
            />
        </>
    );
};

export default ProviderCompaniesListContainer;
